import axios from 'axios';
import { useId, useState } from 'react';
import './inline-contact-form.scss';

/**
 * Contact form that the blog post page drops into the spots where the author inserted the Gravity Forms block.
 * Same form, fields and endpoint as the footer form (Gravity Forms form 1 via the REST API), so leads arrive exactly
 * like the footer ones. The page URL goes into the last field so the lead shows which article it came from.
 */
const formatPhone = (value) => {
    const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
};

export const InlineContactForm = () => {
    const uid = useId();
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [status, setStatus] = useState(null); // null | 'success' | 'error'

    const onSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setStatus(null);
        try {
            await axios.post(
                '/wp-json/gf/v2/forms/1/submissions',
                {
                    'input_1': fullName,
                    'input_3': email,
                    'input_4': phone,
                    'input_5': message,
                    'input_6': window.location.href,
                },
                { headers: { 'Content-Type': 'application/json' } }
            );
            setFullName('');
            setEmail('');
            setPhone('');
            setMessage('');
            setStatus('success');
        } catch (err) {
            console.log(err);
            setStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return <div className="inline-contact-card">
        <div className="inline-contact-title" role="heading" aria-level="2">Get a Free Consultation.</div>
        {status === 'success' && <div className="inline-contact-status success" role="status">Form submitted successfully!</div>}
        {status === 'error' && <div className="inline-contact-status error" role="alert">Sorry, something went wrong. Please try again.</div>}
        <form className="inline-contact-form-el" onSubmit={onSubmit}>
            <div className="inline-contact-fields">
                <input type="text" id={`${uid}-name`} name="name" placeholder="Name" required
                    value={fullName} onChange={(e) => setFullName(e?.target?.value ?? '')} aria-label="Name" />
                <input type="email" id={`${uid}-email`} name="email" placeholder="Email" required
                    value={email} onChange={(e) => setEmail(e?.target?.value ?? '')} aria-label="Email" />
                <input type="tel" id={`${uid}-phone`} name="phone" placeholder="Phone" required
                    value={phone} onChange={(e) => setPhone(formatPhone(e?.target?.value ?? ''))} aria-label="Phone" />
                <textarea id={`${uid}-message`} name="message" placeholder="Tell us about your case"
                    value={message} onChange={(e) => setMessage(e?.target?.value ?? '')} aria-label="Tell us about your case" />
            </div>
            <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Make an appointment'}
            </button>
        </form>
    </div>;
};
